import React from "react";
import Card from "./Card";
import CardSection from "./CardSection";
import tempImage from "../assets/images/temp.jpg";

const HouseCards = ({ projects }) => {
  return (
    <div>
      {projects.length > 0 ? (
        <CardSection>
          {projects.map((project, index) => (
            <Card
              key={index}
              title={project.name}
              description={
                <>
                  <ul>
                    {project.propertyType && <li>{project.propertyType}</li>}
                  </ul>
                </>
              }
              link={`/how-to-apply/project/${project._id}`}
              image={project.imageUrl || tempImage}
            />
          ))}
        </CardSection>
      ) : (
        <p>No current projects available.</p>
      )}
    </div>
  );
};

export default HouseCards;
